var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "" } },
    [
      _c("md-progress", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadingComponent,
            expression: "loadingComponent"
          }
        ],
        staticClass: "md-accent",
        attrs: { "md-indeterminate": "" }
      }),
      _c(
        "md-theme",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loadingComponent,
              expression: "!loadingComponent"
            }
          ],
          attrs: { "md-name": "blue" }
        },
        [
          _c("breadcrumbs", { attrs: { section: "Users", nav: _vm.nav } }),
          _c(
            "stitch-loader",
            { attrs: { loading: _vm.loading, size: 40 } },
            [
              _c(
                "md-layout",
                { staticClass: "form-wrapper", attrs: { "md-gutter": 16 } },
                [
                  _c(
                    "md-whiteframe",
                    {
                      staticClass: "form-wrapper-frame",
                      attrs: { "md-elevation": "3" }
                    },
                    [
                      _c("account-selector", {
                        attrs: {
                          showRequiredError:
                            _vm.formSubmitted &&
                            _vm.$v.user.user_metadata.account_id.$invalid
                        },
                        model: {
                          value: _vm.user.user_metadata.account_id,
                          callback: function($$v) {
                            _vm.$set(_vm.user.user_metadata, "account_id", $$v)
                          },
                          expression: "user.user_metadata.account_id"
                        }
                      }),
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": 100, "md-align": "center" } },
                        [
                          _vm.errorMsg
                            ? _c("span", { staticClass: "on-error" }, [
                                _vm._v(_vm._s(_vm.errorMsg))
                              ])
                            : _vm._e()
                        ]
                      ),
                      _c(
                        "md-input-container",
                        {
                          class: {
                            "md-input-invalid":
                              _vm.formSubmitted &&
                              _vm.$v.user.user_metadata.name.$invalid
                          }
                        },
                        [
                          _c("label", [_vm._v("Name")]),
                          _c("md-input", {
                            model: {
                              value: _vm.user.user_metadata.name,
                              callback: function($$v) {
                                _vm.$set(_vm.user.user_metadata, "name", $$v)
                              },
                              expression: "user.user_metadata.name"
                            }
                          }),
                          _vm.formSubmitted &&
                          !_vm.$v.user.user_metadata.name.required
                            ? _c("span", { staticClass: "md-error" }, [
                                _vm._v("This field is required")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "md-input-container",
                        {
                          class: {
                            "md-input-invalid":
                              _vm.formSubmitted && _vm.$v.user.email.$invalid
                          }
                        },
                        [
                          _c("label", [_vm._v("Email")]),
                          _c("md-input", {
                            model: {
                              value: _vm.user.email,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "email", $$v)
                              },
                              expression: "user.email"
                            }
                          }),
                          _vm.formSubmitted && !_vm.$v.user.email.required
                            ? _c("span", { staticClass: "md-error" }, [
                                _vm._v("This field is required")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "md-input-container",
                        {
                          class: {
                            "md-input-invalid":
                              _vm.formSubmitted && _vm.$v.user.password.$invalid
                          }
                        },
                        [
                          _c("label", [_vm._v("Password")]),
                          _c("md-input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.user.password,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "password", $$v)
                              },
                              expression: "user.password"
                            }
                          }),
                          _vm.formSubmitted && !_vm.$v.user.password.required
                            ? _c("span", { staticClass: "md-error" }, [
                                _vm._v("This field is required")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      !_vm.siteuser.authorization.roles.includes("User")
                        ? _c(
                            "md-input-container",
                            {
                              class: {
                                "md-input-invalid":
                                  _vm.formSubmitted &&
                                  _vm.$v.user.app_metadata.authorization.roles
                                    .$invalid
                              }
                            },
                            [
                              _c("user-roles-selector", {
                                staticClass: "inputRoles",
                                model: {
                                  value:
                                    _vm.user.app_metadata.authorization.roles,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.user.app_metadata.authorization,
                                      "roles",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "user.app_metadata.authorization.roles"
                                }
                              }),
                              _vm.formSubmitted &&
                              !_vm.$v.user.app_metadata.authorization.roles
                                .required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("This field is required")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-align": "center" } },
                [
                  _c("stitch-loader", {
                    attrs: { loading: _vm.creatingOrUpdating, size: 40 }
                  }),
                  _c(
                    "md-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.creatingOrUpdating,
                          expression: "!creatingOrUpdating"
                        }
                      ],
                      staticClass: "md-raised md-primary",
                      attrs: {
                        id: "submit-btn",
                        disabled: _vm.$v.$pending,
                        "md-theme": "blue"
                      },
                      on: { click: _vm.onFormSubmit }
                    },
                    [_vm._v(_vm._s(_vm.editMode ? "Update" : "Create"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50c9815f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c9815f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/user/UserForm.vue
// module id = 732
// module chunks = 0